module.exports = __webpack_public_path__ + "static/media/person-ashish-agarwal.bc884f7d.png";